import familiadosApiClient from '$utils/familiadosApiClient'
import { apiErrorService } from '$utils/services/apiErrorService'
import { apiRouter } from '$domain/model/apiRouter'
import {
  CouponInfoData,
  CouponInfoDataDto,
  InfoDiscountCouponDto,
  CustomerDetailsInfoPremiumDto,
} from '$domain/model/premium/premium.model'
import {
  mapCouponInfoDataToDto,
  mapInfoDiscountCouponDtoToView,
  mapOneTimePremiumPaymentToDto,
  mapCustomerDetailsInfoPremiumDtoToView,
} from '$domain/model/premium/premium.mapper'

export const createCoupon = async (couponInfo: CouponInfoData) => {
  try {
    const couponData = mapCouponInfoDataToDto(couponInfo)
    await familiadosApiClient.post<CouponInfoDataDto>(apiRouter.getCreateCouponPath(), couponData)
  } catch (error) {
    throw apiErrorService.handleError(error)
  }
}

export const checkCouponValidity = async (selectedPlan: string, couponCode: string) => {
  try {
    const infoCoupon = await familiadosApiClient.post<InfoDiscountCouponDto>(apiRouter.getCheckCouponValidityPath(), {
      selectedPlan: mapOneTimePremiumPaymentToDto(selectedPlan),
      couponCode,
    })
    return mapInfoDiscountCouponDtoToView(infoCoupon)
  } catch (error) {
    throw apiErrorService.handleError(error)
  }
}

export const getCustomerDetailsInfoPremium = async () => {
  try {
    const detailsInfoPremium = await familiadosApiClient.get<CustomerDetailsInfoPremiumDto>(
      apiRouter.getCustomerDetailsInfoPremiumPath(),
    )
    return mapCustomerDetailsInfoPremiumDtoToView(detailsInfoPremium)
  } catch (error) {
    throw apiErrorService.handleError(error)
  }
}



// WEBPACK FOOTER //
// ./src/domain/model/premium/premium.manager.ts